<template>
  <IconBxsHeart />
</template>
